module.exports = __webpack_public_path__ + "static/media/not_started_grey.a93ed3ea.svg";